export default __webpack_public_path__ + "2cf9a2804c3cbcef5445ff70e7f8326a.png";